export const getInitials = (firstName: string, lastName?: string) => {
  const firstLetter = (word: string) => word[0];
  if (lastName) return firstLetter(firstName) + firstLetter(lastName);
  return firstLetter(firstName);
};
